import { createContext } from "react";
import { NsTheme, NsThemeName } from "../ns-eds-types";
import { light } from "../ns-theme-light";

export type ThemeContextProps = {
  isLightTheme: boolean;
  setTheme?: (newTheme: NsTheme) => void;
  setThemeByName?: (newTheme: NsThemeName) => void;
  theme: NsTheme;
};

export const ThemeContext = createContext<ThemeContextProps>({
  isLightTheme: true,
  theme: light,
});
